import services from "@/http";
import * as types from "./mutation-types";

export const ActionGetAll = async ({ dispatch }, payload) => {
  let data = await dispatch("ActionFind", payload);
  dispatch("ActionSetparceiros", data.data);
  dispatch("ActionSetPagination", data.meta);
  return data.data;
};

export const ActionFind = async (store, search) => {
  var parceiros = {
    data: [],
    meta: {},
  };

  await services.parceiros.get_all(search).then((res) => {
    parceiros = res.data;
  });
  return parceiros;
};

export const ActionShow = async ({ dispatch }, id) => {
  await services.parceiros.show({ id: id }).then((res) => {
    dispatch("ActionSetparceiro", res.data.parceiro);
  });
};

export const ActionSave = async ({ dispatch }, payload) => {
  if (payload.id) {
    await dispatch("ActionUpdate", payload);
  } else {
    await dispatch("ActionStore", payload);
  }
};

export const ActionStore = async ({ commit }, payload) => {
  await services.parceiros.store(payload).then((res) => {
    commit(types.SET_parceiro, res.data.parceiro);
  });
};

export const ActionUpdate = async ({ commit }, payload) => {
  await services.parceiros.update({ id: payload.id }, payload).then((res) => {
    commit(types.SET_parceiro, res.data.parceiro);
  });
};

export const ActionDelete = async ({ commit }, id) => {
  await services.parceiros.delete({ id: id }).then(() => {
    commit(types.SET_parceiro, null);
  });
};

export const getById = async ({ commit }, id) => {
  const data = await services.parceiros.by_id({ id: id });
  return data.body;
};

export const updatePartnerTypes = async ({ commit }, values) => {
  const data = await services.parceiros.update_partner(values);
  return data.body;
};

export const ActionSetparceiros = ({ commit }, payload) => {
  commit(types.SET_parceiroS, payload);
};

export const ActionSetparceiro = ({ commit }, payload) => {
  commit(types.SET_parceiro, payload);
};

export const ActionSetPagination = ({ commit }, payload) => {
  commit(types.SET_PAGINATION, payload);
};

export const ActionNewparceiro = ({ commit }) => {
  commit(types.SET_parceiro, {});
};

/**
 * @description Actions para Paises
 */

export const ActionFindParceiro = async (store, payload = {}) => {
  let parceiros = [];
  payload.per_page = 50;
  await services.parceiros.get_all(payload).then((res) => {
    parceiros = res.data.data;
  });
  return parceiros;
};

// export const ActionFindPaisByIso = async (store, iso3) => {
//   var pais = null;
//   await services.parceiros.show_parceiros({ nome: nome }).then((res) => {
//     parceiro = res.data.parceiro;
//   });
//   return parceiro;
// };

export const ActionToSelect = async (store) => {
  let response = [];
  await services.parceiros.to_select().then((res) => {
    response = res.data;
  });
  return response;
};
